
import { useState, useEffect, useRef } from "react";
import axiosConfig from '../axiosConfig';
import Header from "../Header/Header";
import MainMenu from "../MainMenu/MainMenu";
import PopUpDetails from "./PopUpDetails";
import { set } from "date-fns";

const DeviceList = () => {

    const [devices, setDevices] = useState([]);
    const [isSubscribed, setIsSubscribed] = useState(false);
    // const [isLoadingHHBoxConnectedHistory, setIsLoadingHHBoxConnectedHistory] = useState(false);
    // const [isLoadingHHDeselectedHistory, setIsLoadingHHDeselectedHistory] = useState(false);
    const [isDownloadingCombined, setIsDownloadingCombined] = useState(false);
    const [query, setQuery] = useState("");
    const [liveStatusChange, setLiveStatusChange] = useState(null);
    const [liveComment, setLiveComment] = useState("");
    const [liveStatusError, setLiveStatusError] = useState("");
    const [isSavingLiveStatus, setIsSavingLiveStatus] = useState(false);
    const liveStatusDialog = useRef(null);
    const liveStatusSaving = useRef(false);

    useEffect(() => {
        if (liveStatusChange) {
            liveStatusDialog.current.showModal();
        } else if (liveStatusDialog.current.open) {
            liveStatusDialog.current.close();
        }
    }, [liveStatusChange]);

    const isLiveEnabled = (device) => Number(device.dashboard_live_enable) === 1;

    const openLiveStatusDialog = (device) => {
        setLiveComment("");
        setLiveStatusError("");
        setLiveStatusChange({ device_id: device.id, name: device.device_name, status: !isLiveEnabled(device) });
    };
    useEffect(() => {
        axiosConfig.get("/device/list").then((rsp) => {
            setDevices(rsp.data);
            //console.log(rsp.data[0]);
        }, (err) => { });


    }, []);

    // const downloadAllHouseholdBoxConnectionHistory = () => {
    //     setIsLoadingHHBoxConnectedHistory(true);
    //     //setHistoryError("");

    //     axiosConfig.get("/device/all-household-box-connected-history")
    //         .then((response) => {
    //             const logs = response.data.all_household_box_history_logs;
    //             if (!logs || logs.length === 0) {
    //                 throw new Error("No history found.");
    //             }

    //             const csv = [
    //                 ["HH ID", "Box ID", "Assigned At", "Assigned By", "Disconnected At", "Disconnected By"]
    //             ];

    //             logs.forEach(log => {
    //                 csv.push([
    //                     log.device_id,
    //                     log.box_id,
    //                     log.connected_at,
    //                     log.connected_by_user ?? "",
    //                     log.disconnected_at ?? "Still Connected",
    //                     log.disconnected_by_user ?? ""
    //                 ]);
    //             });

    //             exportToCsv("box_history_" + new Date().toISOString() + ".csv", csv);
    //         })
    //         .catch((err) => {
    //             //console.error(err);
    //             alert("Failed to download box history. Please try again.");
    //         })
    //         .finally(() => {
    //             setIsLoadingHHBoxConnectedHistory(false);
    //         });
    // };


    // const downloadAllHouseholdDeselectionHistory = () => {
    //     setIsLoadingHHDeselectedHistory(true);
    //     //setHistoryError("");

    //     axiosConfig.get("/device/all-household-deselected-history")
    //         .then((response) => {
    //             //console.log(response.data);
    //             const logs = response.data.all_household_deselect_history;
    //             if (!logs || logs.length === 0) {
    //                 throw new Error("No history found.");
    //             }

    //             const csv = [
    //                 ["HH ID", "Deselected At", "Deselected by", "Selected At", "Selected by"]
    //             ];

    //             logs.forEach(log => {
    //                 csv.push([
    //                     log.device_id,
    //                     log.start_date,
    //                     log.deselected_by_user_name ?? "",
    //                     log.end_date ?? "Still Deselected",
    //                     log.selected_by_user_name ?? ""
    //                 ]);
    //             });

    //             exportToCsv("Household_selected_deseleceted_history_" + new Date().toISOString() + ".csv", csv);
    //         })
    //         .catch((err) => {
    //             //console.error(err);
    //             alert("Failed to download box history. Please try again.");
    //         })
    //         .finally(() => {
    //             setIsLoadingHHDeselectedHistory(false);
    //         });
    // };


    const downloadCombinedHistory = async () => {
        setIsDownloadingCombined(true);

        try {
            const [HHboxConnectionHistoryRes, HHdeselectHistoryRes] = await Promise.all([
                axiosConfig.get("/device/all-household-box-connected-history"),
                axiosConfig.get("/device/all-household-deselected-history"),
            ]);

            const boxLogs = HHboxConnectionHistoryRes.data.all_household_box_history_logs || [];
            const deselectLogs = HHdeselectHistoryRes.data.all_household_deselect_history || [];


            const mergedLogs = [];

            boxLogs.forEach(boxLog => {
                mergedLogs.push([
                    boxLog.device_id,
                    boxLog.box_id,
                    boxLog.connected_at,
                    boxLog.connected_by_user ?? "",
                    boxLog.disconnected_at ?? "Still Connected",
                    boxLog.disconnected_by_user ?? "",
                    "",
                    "",
                    "",
                    ""
                ]);
            });

            deselectLogs.forEach(deselectLog => {
                mergedLogs.push([
                    deselectLog.device_id,
                    "",
                    "",
                    "",
                    "",
                    "",
                    deselectLog.start_date,
                    deselectLog.deselected_by_user_name ?? "",
                    deselectLog.end_date ?? "Still Deselected",
                    deselectLog.selected_by_user_name ?? ""
                ]);
            });


            const csv = [
                ["HH ID", "Box ID", "Assigned At", "Assigned By", "Disconnected At", "Disconnected By", "Deselected At", "Deselected by", "Selected At", "Selected by"],
                ...mergedLogs
            ];

            exportToCsv("household_box_connection_and_deselection_history_" + new Date().toISOString() + ".csv", csv);

        } catch (err) {
            console.error(err);
            alert("Failed to download combined history. Please try again.");
        } finally {
            setIsDownloadingCombined(false);
        }
    };


    const deleteDevice = (id) => {

        const obj = { id: id };
        axiosConfig.post("/device/delete", obj).then((rsp) => {
            setDevices(devices.filter((device) => device.id !== id));
            //window.location.reload(false);
        }, (err) => {
        });
    };

    const Search = (data) => {
        return data.filter(
            (item) =>
                item.device_name.toLowerCase().includes(query.toLowerCase()) ||
                item.deviceBoxId && item.deviceBoxId.toString().includes(query)
        );
    };

    const handleChange = (event, device_id) => {
        if (event.target.checked) {
            //console.log('✅ Checkbox is checked');
            const obj = { device_id: device_id, deselect: 'deselect' };
            axiosConfig.post("/device/deselect", obj).then((rsp) => {
                setDevices(devices.map((device) => {
                    if (device.id === device_id) {
                        return { ...device, deselect: "deselect" };
                    }
                    return device;
                }));

                //window.location.reload(false);
            }, (err) => {
            });

        } else {
            //console.log('⛔️ Checkbox is NOT checked');
            const obj = { device_id: device_id, deselect: '' };
            axiosConfig.post("/device/deselect", obj).then((rsp) => {
                setDevices(devices.map((device) => {
                    if (device.id === device_id) {
                        return { ...device, deselect: "" };
                    }
                    return device;
                }));

                //window.location.reload(false);
            }, (err) => {
            });

        }
        setIsSubscribed(current => !current);

    };


    const Dashboard_Live_Enable_Disable = async (event) => {
        event.preventDefault();
        if (!liveStatusChange || liveStatusSaving.current) return;

        const { device_id, status } = liveStatusChange;
        const comment = liveComment.trim();
        if (!status && !comment) {
            setLiveStatusError("Please enter a comment when disabling live status.");
            return;
        }
        if (comment.length > 255) {
            setLiveStatusError("The comment must not exceed 255 characters.");
            return;
        }

        liveStatusSaving.current = true;
        setIsSavingLiveStatus(true);
        setLiveStatusError("");
        try {
            await axiosConfig.post("/device/dashboard-live-enable-disable", {
                device_id,
                dashboard_live_enable: status,
                comment: comment || null
            });
            setDevices(currentDevices => currentDevices.map((device) => {
                if (device.id === device_id) {
                    return { ...device, dashboard_live_enable: status };
                }
                return device;
            }));
            setLiveStatusChange(null);
        } catch (err) {
            const data = err.response?.data;
            const validationMessages = err.response?.status === 422 && data && typeof data === 'object'
                ? Object.values(data.errors || data).flat().filter(message => typeof message === 'string').join(" ")
                : "";
            setLiveStatusError(validationMessages || data?.message || "Failed to change dashboard live status. Please try again.");
        } finally {
            liveStatusSaving.current = false;
            setIsSavingLiveStatus(false);
        }
    };



    function exportToCsv(filename, rows) {
        var processRow = function (row) {
            var finalVal = '';
            for (var j = 0; j < row.length; j++) {
                var innerValue = row[j] === null ? '' : row[j].toString();
                if (row[j] instanceof Date) {
                    innerValue = row[j].toLocaleString();
                };
                var result = innerValue.replace(/"/g, '""');
                if (result.search(/("|,|\n)/g) >= 0)
                    result = '"' + result + '"';
                if (j > 0)
                    finalVal += ',';
                finalVal += result;
            }
            return finalVal + '\n';
        };
        var csvFile = '';
        for (var i = 0; i < rows.length; i++) {
            csvFile += processRow(rows[i]);
        }
        var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, filename);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }
    var getCSV = (scsv) => {
        exportToCsv("deployed_" + new Date().toLocaleString() + ".csv", scsv)
    }

    const exportDevices = () => {

        //download input
        axiosConfig.post("/entry/download", { operation_type: "download", affected: "device_list" }).then((rsp) => {

            var csv = [["Household ID", "Household Name", "Box Id", "Last Active At", "Deselection Status", "Dashboard Status", "SEC", "Division", "Installation Date", "Deployer", "Survey Date", "1st_Index_User_Name", "1st_Index_User_Info", "2nd_Index_User_Name", "2nd_Index_User_Info", "3rd_Index_User_Name", "3rd_Index_User_Info", "4th_Index_User_Name", "4th_Index_User_Info", "5th_Index_User_Name", "5th_Index_User_Info", "6th_Index_User_Name", "6th_Index_User_Info", "7th_Index_User_Name", "7th_Index_User_Info", "8th_Index_User_Name", "8th_Index_User_Info"]];

            for (var i = 0; i < devices.length; i++) {

                csv.push([
                    devices[i].id,
                    devices[i].device_name,
                    devices[i].deviceBoxId,
                    devices[i].last_request,
                    devices[i].deselect === "deselect" ? "Deselected" : "Selected",
                    devices[i].deselect === 'deselect' ? "Live Disable" : isLiveEnabled(devices[i]) ? "Live Enable" : "Live Disable",
                    devices[i].economic_status,
                    devices[i].district,
                    //devices[i].lat + ", " + devices[i].lng,
                    devices[i].installation_date,
                    devices[i].installer_name,
                    devices[i].survey_date,
                    (devices[i]?.users[0]?.user_name ? devices[i].users[0].user_name : ""),
                    (devices[i]?.users[0]?.gender ? ("Gender:" + (devices[i].users[0].gender == "m" ? "Male" : "Female")) : "") + "" + (devices[i]?.users[0]?.dob ? ", DOB:" + devices[i].users[0].dob : ""),
                    (devices[i]?.users[1]?.user_name ? devices[i].users[1].user_name : ""),
                    (devices[i]?.users[1]?.gender ? ("Gender:" + (devices[i].users[1].gender == "m" ? "Male" : "Female")) : "") + "" + (devices[i]?.users[1]?.dob ? ", DOB:" + devices[i].users[1].dob : ""),
                    (devices[i]?.users[2]?.user_name ? devices[i].users[2].user_name : ""),
                    (devices[i]?.users[2]?.gender ? ("Gender:" + (devices[i].users[2].gender == "m" ? "Male" : "Female")) : "") + "" + (devices[i]?.users[2]?.dob ? ", DOB:" + devices[i].users[2].dob : ""),
                    (devices[i]?.users[3]?.user_name ? devices[i].users[3].user_name : ""),
                    (devices[i]?.users[3]?.gender ? ("Gender:" + (devices[i].users[3].gender == "m" ? "Male" : "Female")) : "") + "" + (devices[i]?.users[3]?.dob ? ", DOB:" + devices[i].users[3].dob : ""),
                    (devices[i]?.users[4]?.user_name ? devices[i].users[4].user_name : ""),
                    (devices[i]?.users[4]?.gender ? ("Gender:" + (devices[i].users[4].gender == "m" ? "Male" : "Female")) : "") + "" + (devices[i]?.users[4]?.dob ? ", DOB:" + devices[i].users[4].dob : ""),
                    (devices[i]?.users[5]?.user_name ? devices[i].users[5].user_name : ""),
                    (devices[i]?.users[5]?.gender ? ("Gender:" + (devices[i].users[5].gender == "m" ? "Male" : "Female")) : "") + "" + (devices[i]?.users[5]?.dob ? ", DOB:" + devices[i].users[5].dob : ""),
                    (devices[i]?.users[6]?.user_name ? devices[i].users[6].user_name : ""),
                    (devices[i]?.users[6]?.gender ? ("Gender:" + (devices[i].users[6].gender == "m" ? "Male" : "Female")) : "") + "" + (devices[i]?.users[6]?.dob ? ", DOB:" + devices[i].users[6].dob : ""),
                    (devices[i]?.users[7]?.user_name ? devices[i].users[7].user_name : ""),
                    (devices[i]?.users[7]?.gender ? ("Gender:" + (devices[i].users[7].gender == "m" ? "Male" : "Female")) : "") + "" + (devices[i]?.users[7]?.dob ? ", DOB:" + devices[i].users[7].dob : ""),
                ]);

            }
            //console.log(csv);
            getCSV(csv);

        }, (err) => {
            alert("Unable to download");
        });
    }


    return (
        <div><Header title="Devices" />
            <MainMenu menu="device" />
            <dialog
                ref={liveStatusDialog}
                aria-labelledby="live-status-title"
                style={{ width: '480px', maxWidth: 'calc(100% - 32px)', border: 'none', borderRadius: '8px', padding: 0 }}
                onCancel={(event) => {
                    event.preventDefault();
                    if (!liveStatusSaving.current) setLiveStatusChange(null);
                }}
            >
                {liveStatusChange && (
                    <form onSubmit={Dashboard_Live_Enable_Disable}>
                        <div className="modal-header">
                            <h5 className="modal-title" id="live-status-title">
                                {liveStatusChange.status ? 'Enable' : 'Disable'} dashboard live status
                            </h5>
                        </div>
                        <div className="modal-body">
                            <p>Household: {liveStatusChange.name} (ID: {liveStatusChange.device_id})</p>
                            <label htmlFor="live-status-comment">
                                Comment {liveStatusChange.status ? '(optional)' : '(required)'}
                            </label>
                            <textarea
                                id="live-status-comment"
                                className="form-control"
                                rows={3}
                                maxLength={255}
                                required={!liveStatusChange.status}
                                value={liveComment}
                                onChange={(event) => setLiveComment(event.target.value)}
                                disabled={isSavingLiveStatus}
                                aria-describedby="live-status-comment-help"
                                autoFocus
                            />
                            <small id="live-status-comment-help">{liveComment.length}/255 characters</small>
                            {liveStatusError && <div className="alert alert-danger mt-1" role="alert">{liveStatusError}</div>}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" disabled={isSavingLiveStatus} onClick={() => setLiveStatusChange(null)}>Cancel</button>
                            <button type="submit" className={`btn btn-${liveStatusChange.status ? 'success' : 'danger'}`} disabled={isSavingLiveStatus}>
                                {isSavingLiveStatus ? 'Saving...' : liveStatusChange.status ? 'Enable live status' : 'Disable live status'}
                            </button>
                        </div>
                    </form>
                )}
            </dialog>
            <div class="app-content content">
                <div class="content-overlay"></div>
                <div class="content-wrapper" style={{ backgroundColor: "azure" }} >
                    <div class="content-header row">
                    </div>
                    <div class="content-body">
                        <div class="row justify-content-md-center">
                            <div class="col-xl-12  col-12">
                                <section id="horizontal-vertical">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="card">

                                                <div class="card-content collapse show">
                                                    <div class="card-body card-dashboard">

                                                        <div class="row">
                                                            <div class="col-md-7"><div class="h3 font-weight-bold">Device List</div></div>
                                                            <div class="col-md-5"><input type="text" class="search form-control round border-primary mb-1" placeholder="Search by Device Name or Box ID" onChange={e => setQuery(e.target.value)} />
                                                            </div>

                                                        </div>
                                                        {/* <a class="btn btn-primary" href="/device/create">Create New</a> */}

                                                        <button class="btn btn-success pull-right" onClick={exportDevices}>Export</button>
                                                        {/* <button class="btn btn-primary pull-right" onClick={downloadAllHouseholdBoxConnectionHistory} disabled={isLoadingHHBoxConnectedHistory}>
                                                            {isLoadingHHBoxConnectedHistory ? "Downloading..." : "Download Box History"}
                                                        </button> */}
                                                        <button class="btn btn-info pull-right" onClick={downloadCombinedHistory} disabled={isDownloadingCombined}>
                                                            {isDownloadingCombined ? "Downloading..." : "Download HH/Box History"}
                                                        </button>

                                                        <div class="table-responsive" style={{ maxHeight: '400px', minHeight: '500px' }}>
                                                            <table class="table display nowrap table-striped table-bordered">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Household</th>
                                                                        <th>Device Box ID</th>
                                                                        <th>Address(Division)</th>
                                                                        <th>Type</th>
                                                                        <th>Economic Status</th>
                                                                        <th>Socio Status</th>
                                                                        <th>Status</th>
                                                                        <th>Operation</th>
                                                                        <th>Dashboard Status</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {Search(devices).map((device) =>
                                                                        <tr key={device.id}>
                                                                            {/*<td><a data-toggle="modal" data-target={`#exampleModal_${device.id}`}>{device.device_name}</a>*<PopUpDetails id={device.id}/></td>*/}
                                                                            <td><a href={`/device/detail/${device.id}`}>{device.device_name}</a></td>
                                                                            <td>{device.deviceBoxId ?? <span class="text-danger">Box Not Contented</span>}</td>
                                                                            <td>{device.district && device.district.charAt(0).toUpperCase() + device.district.slice(1)}</td>
                                                                            <td>{device.type}</td>
                                                                            {/* <td>{user.gender}</td>
                                                                            <td>{user.age}</td> */}
                                                                            <td>{device.economic_status}</td>
                                                                            <td>{device.socio_status}</td>
                                                                            <td style={{ whiteSpace: 'nowrap' }}>
                                                                                <a class="btn btn-secondary" href={`/device/edit/${device.id}`}>Edit</a>
                                                                                {/* <button class="offset-1 btn btn-danger" onClick={() => { if (window.confirm('Delete the item?')) { deleteDevice(device.id) }; }} >Delete</button> */}
                                                                            </td>
                                                                            <td><div><input type="checkbox" id="deselect" onChange={(event) => { if (window.confirm('Want to run This Deselection operation?')) { handleChange(event, device.id) } else {/*window.location.reload(false)*/ } }} value={isSubscribed} checked={device.deselect === "deselect"} name="deselect" />
                                                                                <label class="form-label" >&nbsp; Deselect</label></div>
                                                                            </td>
                                                                            <td>
                                                                                <button type="button" className={`offset-1 btn btn-${device.deselect === 'deselect' ? "danger" : isLiveEnabled(device) ? "success" : "danger"}`} onClick={() => openLiveStatusDialog(device)} disabled={isSavingLiveStatus}>{device.deselect === 'deselect' ? 'Live Disable' : isLiveEnabled(device) ? 'Live Enable' : 'Live Disable'}</button>
                                                                            </td>


                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </table>

                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </section >

                            </div>
                        </div>

                        <br />

                        <br />

                    </div>
                </div>
            </div>
        </div>
    )

}
export default DeviceList;
